module.exports = __webpack_public_path__ + "media/images/avatar/32-e025c4ce2d55ad68cb9e186baf196a37.svg";